// redux-saga
import {call, take, put} from "redux-saga/effects";
// Redux factory
import createFetchRedux from "../createFetchRedux";
// Api configuration
import api from "api";
// Fetch service
import fetch from "services/fetch";
// Redux modules
import {openSnackbar} from "../snackbar/open";

const {reducer, actions, selectors} = createFetchRedux("exportData");
// Reducer
export default reducer;
// Action types
export const EXPORT_CSV = "exportData/EXPORT_CSV";
// Actions
export const fetchExport = actions.fetch;
export const exportData = actions;

export function exportCSV(projectId, version, savedSetName) {
    return {
        type: EXPORT_CSV,
        payload: {
            projectId,
            version,
            savedSetName
        }
    };
}

export function exportDownload(res, projectId , version, savedSetName) {
    const blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
    const anchorEl = document.createElement("a");
    anchorEl.style = "display: none";
    document.body.appendChild(anchorEl);
    const url = window.URL.createObjectURL(blob);
    anchorEl.href = url;
    anchorEl.download = `NeedUnits-${projectId}-${version}-${savedSetName}.xlsx`;
    anchorEl.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(anchorEl);
}

// Selectors
export const selectExportResult = selectors.selectReduxData;
export const selectExportDataLoading = selectors.selectReduxLoading;

// Sagas
export function* watchExport() {
    while (true) {
        const {payload} = yield take(EXPORT_CSV);
        const {projectId, version, savedSetName} = payload;
        const {url, type, error} = api["export.get"](
            projectId,
            version,
            encodeURIComponent(savedSetName)
        );
        try {
            const result = yield call(fetch, url, type, null, null, null, 'binary');
            yield put(exportData.receive(result));
            yield call(exportDownload, result, projectId , version , savedSetName);
        } catch (e) {
            yield put(exportData.error(error));
            yield put(openSnackbar(error, "error"));
            console.error(e);
        }
    }
}
